import '../base';
import '../components/carousels/mobile-carousel';
import '../components/product/product-features';
